import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_meds-admin-dashboard/artifacts/8imnt8cg_cp.logo.png";

export const FOOTER_LOGO_URL =
  "https://customer-assets-jt897jd0.emergentagent.net/job_meds-admin-dashboard/artifacts/9ibn0ouq_cp.logo.png";

export default api;
